import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewTableModule"
const debug = false

export class ViewTableModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_TABLE, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Table"
        this.description                = "The Table View facilitates task management within the project hierarchy by presenting data in a structured and hierarchical format. With customizable settings and inline editing capabilities, along with filters, sorting, quick search, and other advanced features, users can tailor the table view to suit their specific task management needs. The Table View enhances productivity by providing a clear overview of tasks within the project hierarchy, streamlining task organization and management processes."
        this.svgIcon                    = "isvg-view-table"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-table"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}